import * as React from 'react';

import type {EmailAddressee} from 'nutshell-core/types';

import {StatusBadge} from 'shells/status-badge/status-badge';

import {ActorVerbParticipants} from './actor-verb-participants';
import {AvatarScheduledTime} from './avatar-scheduled-time';
import {AvatarWithTime} from './avatar-with-time';
import {Subject} from './subject';

import styles from './email-preview-header.module.css';

type Props = {
    actor: EmailAddressee;
    verb: string;
    participants?: EmailAddressee[];
    subject?: string;
    sentTime?: number | null | undefined;
    scheduledTime?: number | null | undefined;
    isHidden?: boolean;
};

export function EmailPreviewHeader(props: Props) {
    const {actor, verb, participants, subject, sentTime, scheduledTime, isHidden} = props;

    return (
        <div className={styles['email-preview-header']}>
            {sentTime ? (
                <AvatarWithTime
                    avatarUrl={
                        actor.entity && actor.entity.avatarUrl ? actor.entity.avatarUrl : undefined
                    }
                    initials={
                        actor.entity && actor.entity.initials ? actor.entity.initials : undefined
                    }
                    sentTime={sentTime}
                />
            ) : undefined}
            {scheduledTime ? (
                <AvatarScheduledTime
                    avatarUrl={
                        actor.entity && actor.entity.avatarUrl ? actor.entity.avatarUrl : undefined
                    }
                    initials={
                        actor.entity && actor.entity.initials ? actor.entity.initials : undefined
                    }
                    scheduledTime={scheduledTime}
                />
            ) : undefined}
            <div className={styles['header-right']}>
                <div className='flex'>
                    <ActorVerbParticipants actor={actor} verb={verb} participants={participants} />
                    {isHidden ? (
                        <div className={styles.badge}>
                            <StatusBadge level='hidden' text='Private' detail='This is hidden' />
                        </div>
                    ) : null}
                </div>
                {subject ? <Subject subject={subject} /> : null}
            </div>
        </div>
    );
}
